import { BrowserModule } from '@angular/platform-browser';
import { APP_BASE_HREF } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { NgModule, DoBootstrap, ApplicationRef } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AnalyticsDataAccessModule } from '@cigna/analytics/data-access';
import { ChcpAnalyticsUtilModule } from '@cigna/chcp/shared/analytics-util';

import { environment } from '../environments/environment';

import { NxModule } from '@nrwl/angular';

import { CookieModule } from 'ngx-cookie';

import { StoreModule, MetaReducer } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { routerReducer } from '@ngrx/router-store';

import { TranslateModule } from '@ngx-translate/core';

import { CoreWindowModule } from '@cigna/core/window';
import { UiIconModule } from '@cigna/ui/icon';
import { UiButtonModule } from '@cigna/ui/button';

import { ChcpShellUiModule } from '@cigna/chcp/shell/ui';
import {
  ENVIRONMENT_CONFIG,
  ChcpSharedEnvironmentUtilModule,
  CDN_BASE_URL,
} from '@cigna/chcp/shared/environment-util';
import {
  ChcpSharedFeaturesUtilModule,
  permissionToggles,
} from '@cigna/chcp/shared/features-util';
import { FeaturesModule } from '@cigna/features';

export function cdnBaseUrlFactory(baseHref: string) {
  return environment.api.gateways.cdn === ''
    ? baseHref
    : `${environment.api.gateways.cdn}spa/chcp-resources/`;
}

import { resetReducer } from './+state/reset.reducer';
import { ResourcesAppHeaderComponent } from './resources-app-header/resources-app-header.component';
import { ResourcesAppFooterComponent } from './resources-app-footer/resources-app-footer.component';
import { VideoDialogLoaderComponent } from './video-dialog-loader/video-dialog-loader.component';
import { ChcpAuthDataAccessModule } from '@cigna/chcp/auth/data-access';
import { ResourcesModalComponent } from './resources-modal/resources-modal.component';

export const metaReducers: Array<MetaReducer<any>> = [resetReducer];

@NgModule({
  declarations: [
    ResourcesAppHeaderComponent,
    ResourcesAppFooterComponent,
    VideoDialogLoaderComponent,
    ResourcesModalComponent,
  ],
  imports: [
    BrowserModule,
    ChcpShellUiModule,
    HttpClientModule,
    UiButtonModule,
    AnalyticsDataAccessModule,
    ChcpAnalyticsUtilModule,
    CoreWindowModule.forRoot(),
    UiIconModule.forRoot({
      factory: cdnBaseUrlFactory,
      deps: [APP_BASE_HREF],
    }),
    CookieModule.forRoot({
      path: '/',
    }),
    NxModule.forRoot(),
    StoreModule.forRoot(
      {
        router: routerReducer,
      },
      {
        metaReducers,
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
        },
      },
    ),
    StoreDevtoolsModule.instrument(),
    TranslateModule.forRoot(),
    EffectsModule.forRoot([]),
    BrowserAnimationsModule,
    FeaturesModule,
    ChcpSharedFeaturesUtilModule,
    ChcpSharedEnvironmentUtilModule,
    ChcpAuthDataAccessModule.withConfig(environment.oidc, [
      environment.oidc.authorizeUri,
      environment.api.gateways.publicApi,
    ]),
  ],
  providers: [
    {
      provide: APP_BASE_HREF,
      useValue: '/',
    },
    {
      provide: ENVIRONMENT_CONFIG,
      useValue: environment,
    },
    {
      provide: CDN_BASE_URL,
      useFactory: cdnBaseUrlFactory,
      deps: [APP_BASE_HREF],
    },
    {
      provide: 'permissionToggleList',
      useValue: permissionToggles,
    },
    {
      provide: 'chcpSecureApi',
      useValue: environment.api.gateways.secureApi,
    },
  ],
  entryComponents: [
    ResourcesAppHeaderComponent,
    ResourcesAppFooterComponent,
    VideoDialogLoaderComponent,
  ],
})
export class AppModule implements DoBootstrap {
  ngDoBootstrap(appRef: ApplicationRef) {
    if (document.getElementById('chcp-resources-header')) {
      appRef.bootstrap(ResourcesAppHeaderComponent);
    }
    if (document.getElementById('chcp-resources-footer')) {
      appRef.bootstrap(ResourcesAppFooterComponent);
    }
  }
}
